<section class="feature-page">
  <app-page-header title="Configuración" subtitle="Encontrá los catálogos y herramientas para administrar las comunidades."></app-page-header>

  <div class="feature-page__content configuration-content">
    <mat-form-field appearance="outline" class="configuration-search" subscriptSizing="dynamic">
      <mat-label>Buscar en configuración</mat-label>
      <mat-icon matPrefix aria-hidden="true">search</mat-icon>
      <input matInput type="search" [value]="search()" (input)="search.set($any($event.target).value)" placeholder="Ministerios, importaciones, áreas…" />
      @if (search()) {
        <button mat-icon-button matSuffix type="button" aria-label="Limpiar búsqueda" (click)="search.set('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    @if (filteredSections().length) {
      <mat-tab-group class="configuration-tabs" [mat-stretch-tabs]="false" animationDuration="0ms"
        [selectedIndex]="selectedTabIndex()" (selectedIndexChange)="selectTab($event)">
      @for (section of filteredSections(); track section.title) {
        <mat-tab [label]="section.title">
          <header class="section-heading">
            <p>{{ section.description }}</p>
          </header>
          <ul class="option-list">
            @for (option of section.options; track option.route) {
              <li>
                <a class="configuration-option" [routerLink]="option.route">
                  <span class="option-icon"><mat-icon aria-hidden="true">{{ option.icon }}</mat-icon></span>
                  <span class="option-copy">
                    <span class="option-title">{{ option.title }}</span>
                    <span class="option-description">{{ option.description }}</span>
                  </span>
                  <mat-icon class="option-arrow" aria-hidden="true">chevron_right</mat-icon>
                </a>
              </li>
            }
          </ul>
        </mat-tab>
      }
      </mat-tab-group>
    } @else {
        <div class="empty-search" role="status">
          <mat-icon aria-hidden="true">search_off</mat-icon>
          <h2>No encontramos opciones</h2>
          <p>Probá con otro término o limpiá la búsqueda.</p>
          <button mat-button type="button" (click)="search.set('')">Mostrar todas las opciones</button>
        </div>
    }
    @if (!search()) {
      <p class="upcoming-setting"><mat-icon aria-hidden="true">settings</mat-icon> Configuración general del sistema <span>Próximamente</span></p>
    }
  </div>
</section>
